import { mutateByPath } from "../../../utility";
import { ArsContextState, IArsActionLoadArsPatch } from "../interface";

/**
 * Applies synced provider updates without creating undo history or marking the state changed.
 *
 * @param state - Current ARS context state
 * @param action - Load-patch action containing only the changed synced slices
 * @returns Updated state with the supplied synced values applied
 */
export const arsc_loadArsPatch = <T>(
  state: ArsContextState<T>,
  action: IArsActionLoadArsPatch,
): ArsContextState<T> => {
  let newState = state;

  action.updates.forEach((update) => {
    newState = mutateByPath(newState, update.dataPath, update.value);
  });

  return newState;
};
